module.exports = __webpack_public_path__ + "img/name.f47d657f.png";